import { HTTP } from '@/lib/http/client';
import Zone from '@/models/zone';

export default class ZonesApi {
  static async getAll(): Promise<Zone[]> {
    const res = await HTTP.get('zones');
    return res.data;
  }
}
